var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return !_vm.noLabelSetting
    ? _c(
        "el-form-item",
        { attrs: { label: _vm.i18nt("designer.setting.label") } },
        [
          _c("el-input", {
            attrs: { type: "text" },
            model: {
              value: _vm.optionModel.label,
              callback: function ($$v) {
                _vm.$set(_vm.optionModel, "label", $$v)
              },
              expression: "optionModel.label",
            },
          }),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }